import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa32(props) {
  return <Spacer className={props.className} />;
}

Spa32.propTypes = {
  className: PropTypes.string,
};

export default Spa32;
